import { trigger, transition, query, style, animate } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { Camera } from '@classes/camera/camera';
import { DashBoardInfos } from '@classes/dashboard/dashboard';
import { faInfoCircle, faSearch, faCar, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { CamerasService } from '@services/cameras/cameras.service';
import { CompareDateService } from '@services/compare-date/compare-date.service';
import { DashbordService } from '@services/dashboard/dashbord.service';
import { ExportExcelFileService } from '@services/export-excel-file/export-excel-file.service';

@Component({
  selector: 'app-occupancy-rate',
  templateUrl: './occupancy-rate.component.html',
  styleUrls: ['./occupancy-rate.component.scss'],
  animations: [
    trigger('show', [
      transition(':enter', [
        query('.divChart', [
          style({ opacity: 0, transform: 'translate(200px)' }),
          animate('.17s', style({ opacity: 1, transform: 'none' })),
        ], { optional: true })
      ]),
    ]),
  ]
})
export class OccupancyRateComponent implements OnInit {

  faInfoCircle = faInfoCircle;
  faSearch = faSearch;
  faCar = faCar;
  faFileExcel = faFileExcel;

  loading = false;

  daysSelected = [];
  daysGraph = [];
  dayWeekLib = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
  datas: DashBoardInfos[];


  color: ThemePalette = 'primary';

  date = new Date();
  camera: Camera[];

  choiceDateForm: UntypedFormGroup;
  today = new Date();
  sevenDay: Date;

  fileName = 'ExcelSheet.xlsx';

  constructor(
    private dashboardService: DashbordService,
    private exportExportExecelFileService: ExportExcelFileService,
    private formBuilder: UntypedFormBuilder,
    private cameraService: CamerasService,
    private compareDate: CompareDateService
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.getCameras();
  }

  onSubmit(changeCamera: boolean): void {

    this.loading = false;
    const newDate = {
      camera: this.choiceDateForm.get('cameraId').value,
      from: this.choiceDateForm.get('from').value,
      to: this.choiceDateForm.get('to').value,
    };

    const cameraId = this.camera.find(item => item.name === this.choiceDateForm.get('cameraId').value).id;

    this.getDashBoardInfos(cameraId, newDate.from, newDate.to, changeCamera);

  }

  exportexcel(): void {

    const cameraId = this.choiceDateForm.get('cameraId').value;
    const from = this.formatDate(this.choiceDateForm.get('from').value);
    const to = this.formatDate(this.choiceDateForm.get('to').value);

    const excelFile = [];

    this.datas.forEach(day => {
      const infosDay = {
        Camera: cameraId,
        Jour: day.label,
        From: from,
        To: to,
        'Valeur (%)': day.maxValue,
        '0h': day.data[0].value,
        '1h': day.data[1].value,
        '2h': day.data[2].value,
        '3h': day.data[3].value,
        '4h': day.data[4].value,
        '5h': day.data[5].value,
        '6h': day.data[6].value,
        '7h': day.data[7].value,
        '8h': day.data[8].value,
        '9h': day.data[9].value,
        '10h': day.data[10].value,
        '11h': day.data[11].value,
        '12h': day.data[12].value,
        '13h': day.data[13].value,
        '14h': day.data[14].value,
        '15h': day.data[15].value,
        '16h': day.data[16].value,
        '17h': day.data[17].value,
        '18h': day.data[18].value,
        '19h': day.data[19].value,
        '20h': day.data[20].value,
        '21h': day.data[21].value,
        '22h': day.data[22].value,
        '23h': day.data[23].value,
      };
      excelFile.push(infosDay);
    });

    this.exportExportExecelFileService.exportAsExcelFile(excelFile, cameraId);
  }

  checkIfIsInDaySelected(day: string): boolean {
    const inDaysArray = this.daysGraph.find(item => item === day);
    return inDaysArray ? true : false;
  }

  selectedOrNot(day: string): void {
    const dSelect = document.getElementById(`${day}`);
    dSelect.style.display !== 'none' ? dSelect.style.display = 'none' : dSelect.style.display = 'block';
  }

  chartClicked(e: any): void {

  }

  chartHovered(e: any): void {

  }

  changeValueInputFrom(): void {
    const dateFrom = new Date(this.f.from.value).getTime();
    const dateTo = new Date(this.f.to.value).getTime();

    const date = new Date(this.f.to.value);
    date.setDate(date.getDate() - 7);

    if (dateTo <= dateFrom) {
      this.f.from.value.setValue(date);
    }

  }

  sendDateTo(index: number): Date {
    const date = new Date(this.f.from.value);
    const newDate = new Date(date.setDate(date.getDate() + index));

    return newDate;
  }

  private getCameras(): void {
    this.cameraService.getCameras().subscribe(res => {
      this.camera = res;

      const CameraSmartParking = res.filter(c => c.application.ApplicationName === 'SmartParking')


      this.f.cameraId.setValue(this.camera[0].name);

      const date = new Date();
      date.setDate(date.getDate() - 7);

      this.getDashBoardInfos(this.camera[0].id, date, this.today.toString());
    });
  }

  get f() {
    return this.choiceDateForm.controls;
  }

  private getDashBoardInfos(id: string, from: any, to: string, changeCamera?: boolean): void {

    let dataWithoutOrder = [];
    from = this.formatDate(from);
    to = this.formatDate(to, true);

    const date1 = new Date(from);
    const date2 = new Date(to);

    date2.setHours(23);
    date2.setMinutes(59);


    const diff = this.compareDate.compareTwoDate(date1, date2);
    const allDaysIndex: number[] = [];

    for (let i = 0; i < diff; i++) {
      allDaysIndex.push(date1.getDay());
      date1.setDate(date1.getDate() + 1);
    }

    setTimeout(() => {
      this.dashboardService.getInfosDashboard(id, from, to).subscribe(res => {
        this.datas = [];
        this.daysGraph = [];
        this.daysSelected = [];

        res.forEach((item, index) => {

          if (diff >= 8) {
            this.daysGraph.push(item.label);
            dataWithoutOrder = res;
          } else {
            const dayIndex = allDaysIndex.findIndex(d => d === index);
            if (dayIndex !== -1) {
              this.daysGraph.push(item.label);
              dataWithoutOrder.push(item);
            }
          }
        });

        for (const i of allDaysIndex) {

          const indexDay = dataWithoutOrder.findIndex(d => d.label === this.dayWeekLib[i]);
          const indexDayValue = dataWithoutOrder.find(d => d.label === this.dayWeekLib[i]);
          this.daysSelected.push(this.dayWeekLib[i]);

          if (indexDay !== -1) { this.datas.push(dataWithoutOrder[indexDay]); }
          if (this.datas.length === 7) { break; }

        }

        if (changeCamera) {
          setTimeout(() => {
            const inputs = document.querySelectorAll('input');
            inputs.forEach(el => {
              if (el.type === 'checkbox' && el.checked === false) {
                const day = el.id.split('-');
                const graph = document.getElementById(`${day[0]}`);
                if (graph !== null) {

                  graph.style.display = 'none';

                }
              }
            });
          }, 500);
        }

        this.loading = true;
      });

    }, 2000);

  }

  private formatDate(date, to?: boolean) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();

    const year = d.getFullYear();

    if (month.length < 2) { month = '0' + month; }
    if (day.length < 2) { day = '0' + day; }

    return [year, month, day].join('-');
  }


  private initForm(): void {
    const date = new Date();
    date.setDate(date.getDate() - 7);

    this.choiceDateForm = this.formBuilder.group({
      cameraId: ['', Validators.required],
      from: [date, Validators.required],
      to: [this.today, Validators.required]
    });

  }

}
